import { useBetbook } from "~/store/betbook";
import { useSettings } from "~/store/settings";

const useCollapsedView = () => {
	const betbook = useBetbook();
	const settings = useSettings();
	const route = useRoute();
	const isCollapsed = ref(false);
	watchEffect(() => {
		const { fixtureType } = route.params;
		const isSportExcluded = ["horse-racing"].includes(route.params.sportId as string);
		if (
			(fixtureType ||
				betbook.filters.sortOrder !== "League" ||
				!!betbook.filters.regionAndLeagueIds ||
				!!betbook.filters.fromStartEpoch ||
				!!betbook.filters.toStartEpoch ||
				!!betbook.filters.odds ||
				!!betbook.filters.boostedOnly ||
				route.name === "outrights") &&
			window.innerWidth <= 1280 &&
			!settings.simpleView &&
			(route.name === "sport-sportId" || route.name === "sport-sportId-fixtureType" || route.name === "outrights") &&
			settings.hasFeature("IsCollapsedViewEnabled") &&
			!isSportExcluded
		) {
			isCollapsed.value = true;
		} else {
			isCollapsed.value = false;
		}
	});

	return isCollapsed;
};

export default useCollapsedView;
